import { IntercomProvider } from "@medoma/support/IntercomProvider";
import { useIntercomToken } from "@medoma/support/useIntercomToken";
import type { ReactNode } from "react";
import { logisticsApi } from "@/api/ApiClient";
import { useUserProfile } from "@/api/Users";
import { ENVIRONMENT, INTERCOM_APP_ID } from "@/Utils/EnvUtils";

export const CenterIntercomProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { givenName, employeeNumber, organization } = useUserProfile();
  const userId = `${ENVIRONMENT === "local" ? "dev" : ENVIRONMENT}-${organization}-${employeeNumber}`;
  const {
    data: token,
    isPending,
    isError,
  } = useIntercomToken({
    userId,
    getIntercomToken: () => logisticsApi.post(`/intercom/token`).json(),
  });

  return (
    <IntercomProvider
      appId={INTERCOM_APP_ID}
      name={givenName}
      userId={userId}
      token={token}
      isPending={isPending}
      isError={isError}
    >
      {children}
    </IntercomProvider>
  );
};
